import { useMedia } from 'react-use';

import { mobileAndAbove } from 'style/mediaQuery';

export const useIsMobileAndAbove = () => useMedia(mobileAndAbove);
